import client from '../helpers/HttpClient';
import handleError from '../helpers/error';

class userLockService {    
  async fetch(params) {
    try {      
      const result = await client.get('userlock/index', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
}

export default new userLockService();
